import React from 'react';
import getIn from 'components/connectedForm/utils/getIn';
import fieldMetaData from 'graphql/schema/fieldMetaData';
import isFunction from '../../react-data-grid/utils/isFunction';

const DropdownFormatter = (props) => {
  const {
    value,
    column: { options },
  } = props;
  if (!value) {
    return <div />;
  }

  const findEnumValue = (option) => {
    return option.value === props.value;
  };

  let displayValue = value;
  if (options && options.dropdown) {
    displayValue = getIn(value, options.dropdown.labelKey);
    if (options.dropdown.isEnum) {
      const values = fieldMetaData[props.column.options.type].enumValues;
      const option = values.find(findEnumValue);
      displayValue = option?.label ?? 'OPTION MISSING';
    }
    if (options.dropdown.valueRenderer && props.value) {
      const ValueRenderer = options.dropdown.valueRenderer;
      displayValue = <ValueRenderer option={props.value} />;
    }
  }
  let title = getIn(props, 'dependentValues.options.title');
  if (isFunction(title)) {
    title = title(props.dependentValues.rowData);
  }
  if (!title) {
    title = displayValue;
  }

  return <div title={title}>{displayValue}</div>;
};

export default DropdownFormatter;
